import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProviderParserFileList, TProviderParserFileListResponse, TProviderParserFilePayload } from '../../types';
import { useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_PARSER_FILE } from '../../backend-paths';


export const providerParserFileUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_PROVIDER_PARSER_FILE}`,
	(payload: TProviderParserFilePayload, thunkApi) => {
		const dataRequest = { files: payload };

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		};

		return HttpService.put<TProviderParserFileListResponse>(BACKEND_ADMIN_PROVIDER_PARSER_FILE, dataRequest, config).then(result => {
			return result.data;
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TProviderParserFileList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	error: undefined,
};

export const providerParserFileUpdateSlice = createSlice({
	name: 'providerParserFileUpdateSlice',
	initialState,
	reducers: {
		clearProviderParserFileUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerParserFileUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerParserFileUpdateApi.fulfilled.type]: (state, action: PayloadAction<TProviderParserFileList>) => {
			state.isLoading = false;
			state.list = action.payload;
		},

		[providerParserFileUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderParserFileUpdateSelector = () => useAppSelector(state => state[providerParserFileUpdateSlice.name]);

export const { clearProviderParserFileUpdate } = providerParserFileUpdateSlice.actions;
